// extracted by mini-css-extract-plugin
export default {"footerActions":"FooterActions_footerActions__AY8aJ","footerActionBtn":"FooterActions_footerActionBtn__Bkg4K"};